import fetcher from 'helpers/fetcher';

export default {
	put (form) {
		return fetcher.put('user/incoming-transactions', {}, {
			params: { incomingTransactions: form }
		});
	}
};
